export function getValidatedPage(pageParam: string | null): number {
  const parsed = parseInt(pageParam ?? "", 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : 1; // URL page params are 1 based
}
